import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';

import { TransportCardBillComponent } from './transport-card-bill/transport-card-bill.component';

import { BaryCardComponent } from '../../components';

import { TransportTotalPipe } from '../../../pipes/transport-total.pipe';
import { TransportPeriodPipe } from '../../../pipes/transport-period.pipe';
import { TransportAddressPipe } from '../../../pipes/transport-address.pipe';
import { TransportContactPipe } from '../../../pipes/transport-contact.pipe';
import { TransportConstraintsPipe } from '../../../pipes/transport-constraints.pipe';
import { TransformBooleanToYesOrNoPipe } from '../../../pipes/transform-boolean-to-yes-or-no.pipe';

import { TranslateDirective } from '../../../../directives/translate.directive';
import { CurrentDataService } from '../../../../services/current-data-service';

import { AbstractTransport } from '../../../../models/abstract-transport.model';
import { ICustomer } from '../../../../models/customer.model';
import { LIST_SERVICE_TYPE } from '../../../../models/offer-service-type.model';
import { QuotationView } from '../../../../models/quotation-view.model';
import { TransportOrder } from '../../../../models/transport-order.model';
import { AccountService } from 'services/account.service';

@Component({
  selector: 'jhi-transport-card',
  templateUrl: './transport-card.component.html',
  styleUrls: ['./transport-card.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    BaryCardComponent,
    TransportCardBillComponent,
    TranslateDirective,
    CurrencyPipe,
    TransportTotalPipe,
    TransportPeriodPipe,
    TransportAddressPipe,
    TransportContactPipe,
    TransportConstraintsPipe,
    TransformBooleanToYesOrNoPipe,
    CommonModule,
    TranslateModule,
    MDBBootstrapModulesPro,
  ],
})
export class TransportCardComponent implements OnInit {
  readonly #currentDataService = inject(CurrentDataService);

  @Input() public transport!: AbstractTransport;

  private accountService = inject(AccountService);

  protected readonly LIST_SERVICE_TYPE = LIST_SERVICE_TYPE;

  protected customer?: ICustomer;

  public ngOnInit(): void {
    this.#currentDataService.getCustomer().subscribe(customer => (this.customer = customer));
  }

  public getTransportTypeIcon(): string {
    return this.transport.getOptionsTypeSelector().icon;
  }

  public isTransportOrder(t: AbstractTransport): t is TransportOrder {
    return t instanceof TransportOrder;
  }

  public checkIfIsAllowedToShowPricingBloc(): boolean {
    // On ne veut pas permettre à un utilisateur non connecté de pouvoir voir le tarif.
    const auth = this.accountService.getAuthority();
    if (!auth) {
      return false;
    }
    // On ne veut pas afficher le bloc dans le détail d'une demande de devis à valider côté modérateur
    if (this.transport instanceof QuotationView && !this.transport.quotationBasePrice) {
      return false;
    }
    // Pour le reste, on veut l'afficher
    return true;
  }
}
